
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/app-bar",
      function () {
        return require("private-next-pages/material-ui/api/app-bar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/app-bar"])
      });
    }
  